var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53299 1C6.55946 1 3.50926 2.72101 1.10801 6.16303C1.03946 6.26236 1.0019 6.37978 1.00007 6.50045C0.998237 6.62111 1.03221 6.73962 1.0977 6.84098C2.94271 9.72905 5.95209 11.9876 9.53299 11.9876C13.075 11.9876 16.1462 9.72218 17.9946 6.82763C18.0586 6.72825 18.0926 6.61256 18.0926 6.49438C18.0926 6.37619 18.0586 6.26051 17.9946 6.16113C16.142 3.29977 13.0483 1 9.53299 1Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54577 9.54563C11.2314 9.54563 12.5979 8.17916 12.5979 6.49352C12.5979 4.80788 11.2314 3.44141 9.54577 3.44141C7.86013 3.44141 6.49365 4.80788 6.49365 6.49352C6.49365 8.17916 7.86013 9.54563 9.54577 9.54563Z",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.1923363a8f30ccd0228ba39caf67f375.svg";
export { ForwardRef as ReactComponent };